import styled from 'styled-components';

// Общие тон-токены и хелперы вкладок диспетчера. Вынесены сюда, чтобы
// DispatcherPage и SentTab не дублировали палитру бейджей и формат дат.

export type Tone =
  | 'info'
  | 'warning'
  | 'success'
  | 'danger'
  | 'neutral'
  | 'accent'
  | 'purple';

export const TONE_COLORS: Record<Tone, { bg: string; fg: string; border: string }> = {
  info:    { bg: 'rgba(46, 134, 222, 0.16)',  fg: '#2e86de', border: 'rgba(46, 134, 222, 0.45)' },
  warning: { bg: 'rgba(245, 124, 0, 0.18)',   fg: '#f57c00', border: 'rgba(245, 124, 0, 0.45)' },
  success: { bg: 'rgba(30, 142, 62, 0.18)',   fg: '#1e8e3e', border: 'rgba(30, 142, 62, 0.45)' },
  danger:  { bg: 'rgba(208, 72, 72, 0.18)',   fg: '#d04848', border: 'rgba(208, 72, 72, 0.45)' },
  neutral: { bg: 'rgba(120, 120, 120, 0.16)', fg: '#888',    border: 'rgba(120, 120, 120, 0.40)' },
  accent:  { bg: 'rgba(124, 58, 237, 0.16)',  fg: '#7c3aed', border: 'rgba(124, 58, 237, 0.45)' },
  purple:  { bg: 'rgba(165, 79, 230, 0.16)',  fg: '#a54fe6', border: 'rgba(165, 79, 230, 0.45)' },
};

export const ToneBadge = styled.span<{ $tone: Tone }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border-radius: ${({ theme }) => theme.radius.pill};
  background: ${({ $tone }) => TONE_COLORS[$tone].bg};
  color: ${({ $tone }) => TONE_COLORS[$tone].fg};
  border: 1px solid ${({ $tone }) => TONE_COLORS[$tone].border};
  white-space: nowrap;
`;

/** Локализованный формат даты-времени для списков диспетчера. */
export function formatDt(iso?: string | null): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
